import { GetCurrentProfessional, LoggedUser } from '@professionals/professionals.types'
import irisApi from '@services/iris-api'

export const getCurrentProfessional: GetCurrentProfessional = async () => {
  const url = `/v1/me`
  const { data } = await irisApi.get<LoggedUser>(url)

  return data
}
